import React, { useEffect } from "react";
import { Route, Routes } from "react-router";
import Modal from "./components/Modal/Modal";
import AboutUs from "./components/screen components/AboutUs";
import ContactUs from "./components/screen components/ContactUs";
import Home from "./components/screen components/Home";
import Login from "./components/screen components/Login";
import MoviesPage from "./components/screen components/Movies";
import NotFound from "./components/screen components/NotFound";
import Register from "./components/screen components/Register";
import SingleMovies from "./components/screen components/SingleMovies";
import WatchPage from "./components/screen components/WatchPage";
import StartPage from "./components/StartPage";
import StartPageLogin from "./components/StartPageLogin";
import StartPageRegister from "./components/StartPageRegister";
import MoviesInfo from "./components/single/MoviesInfo";
import { animateScroll } from "react-scroll";
import { useLocation } from "react-router-dom";

const App = () => {
  //to initiate every new page in the browser from top

  const location = useLocation();
  useEffect(() => {
    animateScroll.scrollToTop({
      duration: 0,
    });
  }, [location.pathname]);

  return (
    <div className="w-full">
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/movies" element={<MoviesPage />} />
        <Route path="/moviess" element={<MoviesInfo />} />
        <Route path="/movies/:id" element={<SingleMovies />} />
        <Route path="/watch/:id" element={<WatchPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/startlogin" element={<StartPageLogin />} />
        <Route path="/startregister" element={<StartPageRegister />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Modal />
    </div>
  );
};

export default App;
